import React from "react";

import logo from "../assets/logo.svg";

const Hero = () => (
  <div className="text-center hero my-5">
    <img className="mb-3 app-logo" src={logo} alt="React logo" width="120"/>
    <h1 className="mb-4">EVERYDAY OF COURSE!!!!!!</h1>

    <p className="lead">
      To find out what you should be doing everyday go here --->>>
      <a href="https://bike.dev.bddevops.com">activity app</a>
    </p>
  </div>
);

export default Hero;
